import * as React from 'react'

const SvgDashBoardPaperIcon = (props) => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.665039"
      width="48"
      height="48"
      rx="10"
      fill="url(#paint0_linear_3997_87806)"
    />
    <path
      d="M32.665 21.5V18.8C32.665 17.1198 32.665 16.2798 32.3381 15.638C32.0504 15.0735 31.5915 14.6146 31.027 14.327C30.3853 14 29.5452 14 27.865 14H21.465C19.7849 14 18.9448 14 18.3031 14.327C17.7386 14.6146 17.2796 15.0735 16.992 15.638C16.665 16.2798 16.665 17.1198 16.665 18.8V29.2C16.665 30.8802 16.665 31.7202 16.992 32.362C17.2796 32.9265 17.7386 33.3854 18.3031 33.673C18.9448 34 19.7849 34 21.465 34H26.665M26.665 23H20.665M22.665 27H20.665M28.665 19H20.665M29.165 27.0022C29.3412 26.5014 29.689 26.079 30.1468 25.81C30.6045 25.5409 31.1427 25.4426 31.6661 25.5324C32.1894 25.6221 32.664 25.8942 33.006 26.3004C33.3479 26.7066 33.5351 27.2207 33.5343 27.7517C33.5343 29.2506 31.286 30 31.286 30M31.3149 33H31.3249"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3997_87806"
        x1="26.696"
        y1="1.2889e-06"
        x2="36.6656"
        y2="45.8313"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3F76FF" />
        <stop offset="1" stopColor="#444CE7" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDashBoardPaperIcon
